import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a bookcase (~0.9 x 0.35 x 2.0): oak frame with a walnut back,
// four shelves and rows of books as thin blocks in muted colours.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";
const BOOK_BRICK = "#a05a40";
const BOOK_BLUE = "#8a9aa8";
const BOOK_GREEN = "#6f7d68";
const BOOK_BEIGE = "#c9c2b6";

export const bookshelf = defineModel({
  id: "bookshelf",
  batchId: "modern",
  name: "Bookshelf",
  tags: ["modern", "interior", "furniture", "storage", "living-room", "books"],
  summary: "An oak bookcase with four shelves of books.",
  tiles: { w: 1, h: 1 },
  footprint: 1.2,
  parts(): Part[] {
    return [
      // frame — sides, top, bottom, back
      { geometry: new THREE.BoxGeometry(0.03, 2.0, 0.35), color: OAK, position: [-0.435, 1.0, 0] },
      { geometry: new THREE.BoxGeometry(0.03, 2.0, 0.35), color: OAK, position: [0.435, 1.0, 0] },
      { geometry: new THREE.BoxGeometry(0.9, 0.03, 0.35), color: OAK, position: [0, 1.985, 0] },
      { geometry: new THREE.BoxGeometry(0.84, 0.03, 0.32), color: OAK, position: [0, 0.05, 0.01] },
      { geometry: new THREE.BoxGeometry(0.84, 1.94, 0.02), color: WALNUT, position: [0, 1.0, -0.16] },
      // four shelves
      { geometry: new THREE.BoxGeometry(0.84, 0.03, 0.32), color: OAK, position: [0, 0.42, 0.01] },
      { geometry: new THREE.BoxGeometry(0.84, 0.03, 0.32), color: OAK, position: [0, 0.82, 0.01] },
      { geometry: new THREE.BoxGeometry(0.84, 0.03, 0.32), color: OAK, position: [0, 1.22, 0.01] },
      { geometry: new THREE.BoxGeometry(0.84, 0.03, 0.32), color: OAK, position: [0, 1.62, 0.01] },
      // book blocks per shelf
      { geometry: new THREE.BoxGeometry(0.55, 0.26, 0.2), color: BOOK_BRICK, position: [-0.1, 0.195, 0.02] },
      { geometry: new THREE.BoxGeometry(0.2, 0.22, 0.2), color: BOOK_GREEN, position: [0.28, 0.175, 0.02] },
      { geometry: new THREE.BoxGeometry(0.4, 0.26, 0.2), color: BOOK_BLUE, position: [-0.18, 0.565, 0.02] },
      { geometry: new THREE.BoxGeometry(0.3, 0.24, 0.2), color: BOOK_BEIGE, position: [0.2, 0.555, 0.02] },
      { geometry: new THREE.BoxGeometry(0.6, 0.26, 0.2), color: BOOK_GREEN, position: [0.05, 0.965, 0.02] },
      { geometry: new THREE.BoxGeometry(0.35, 0.26, 0.2), color: BOOK_BRICK, position: [-0.2, 1.365, 0.02] },
      { geometry: new THREE.BoxGeometry(0.25, 0.22, 0.2), color: BOOK_BLUE, position: [0.15, 1.345, 0.02] },
      { geometry: new THREE.BoxGeometry(0.45, 0.24, 0.2), color: BOOK_BEIGE, position: [-0.12, 1.755, 0.02] },
    ];
  },
  animations: [],
});
